import { FireworkIcon } from './FireworkIcon';

/**
 * author: Augustin Ursu
 * id 6385008C-99E4-4459-8B18-0CD594EC5C7E
 * name firework
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/firework.svg
 * tags
 * - Holiday 
 */
export const BottleRocketIcon = FireworkIcon;
export default BottleRocketIcon